import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {DownOutlined} from '@ant-design/icons';
import type {MenuProps} from 'antd';
import {Button, Dropdown, Modal,Spin} from 'antd';
import axios from 'axios';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {geos, IGeo} from '../../config/geo';
import {Store} from '../../model/store/Store';

import cls from './Header.module.scss'

interface Props {
    small?: boolean
}

export function geoToEnum (input: string):string|null {
    switch (input) {
        case 'MX': return 'MX';
        case 'ES': return 'ES';
        case 'VN': return 'VN';
        default: return null;
    }
}

export const SelectGeo = observer(({small}:Props) => {

    const [loading, setLoading] = useState(true);

    const {t} = useTranslation();
    const {geo, rate} = useInstance(Store)
    const {i18n} = useTranslation();

    useEffect(() => {
        if (geo.geo === null) {
             axios
                .get('https://api.country.is/')
                .then((data) => {
                    // console.log(data.data)
                    setLoading(false);
                    if (data && data.data && data.data.country) {
                        if (geoToEnum(data.data.country)) {
                            geo.setGeo(geoToEnum(data.data.country));
                        }
                    }
                })
        }
    }, [geo, geo.geo]);
    
    const items: MenuProps['items'] = _.map(geos, item => (
        {
            key: item.key,
            label: t(item.name),
            icon: item.icon,
            onClick: () => {
                geo.setGeo(item.key);
                rate.setCurrency(item.currency);
                i18n.changeLanguage(item.language);
            }
        }
    ))

    // @ts-ignore
    const current:IGeo = _.find(geos, {key: geo.geo})
    // console.log('current', current)

    return (
        <>
            <Modal open={geo.geo === null} footer={null} closable={false}>
                {loading ?
                    <Spin spinning={loading}></Spin>
                    :
                    <>
                        <h2>{t('Select country')}</h2>
                        <div className={cls.grid}>
                            {_.map(geos, item => (
                                <Button key={item.key} size={'large'} block icon={item.icon} onClick={() => {
                                    geo.setGeo(item.key);
                                    rate.setCurrency(item.currency);
                                    i18n.changeLanguage(item.language);
                                }}>{t(item.name)}</Button>
                            ))}
                        </div>
                    </>
                }

            </Modal>
            {geo.geo !== null && (
                <Dropdown menu={{items}}>
                    <Button size={small ? 'small' : 'large'}>{current.icon} {t(current.name)}<DownOutlined/></Button>
                </Dropdown>
            )}
        </>
    )
})